import { CollectionFieldSchema, CollectionFieldType } from '@candu-ai/collections/types';
import { BuiltInComponents } from 'craft/constants';
import { CollectionTargetLocation } from 'craft/types';
import { ComponentSchema } from 'craft/types/schema';

const textComponents = [
  BuiltInComponents.ListItem,
  BuiltInComponents.Typography,
  BuiltInComponents.Button,
];
const linkComponents = [BuiltInComponents.Link, BuiltInComponents.Button, BuiltInComponents.Card];

export const getCollectionEmbedLocationForURL = (
  field: CollectionFieldSchema,
  schema: ComponentSchema,
): CollectionFieldSchema | null => {
  if (!schema?.actions || !linkComponents.includes(schema.type as BuiltInComponents)) {
    return null;
  }
  return field;
};

export const getCollectionEmbedLocationForString = (
  field: CollectionFieldSchema,
  schema: ComponentSchema,
): CollectionFieldSchema | null => {
  if (!textComponents.includes(schema.type as BuiltInComponents)) {
    return null;
  }
  return field;
};

export const getCollectionEmbedLocationForFieldType = (
  field: CollectionFieldSchema,
  schema: ComponentSchema,
): {
  [CollectionTargetLocation.Image]?: CollectionFieldSchema | null;
  [CollectionTargetLocation.ActionURL]?: CollectionFieldSchema | null;
  [CollectionTargetLocation.Text]?: CollectionFieldSchema | null;
} => {
  if (field.type === CollectionFieldType.Image) {
    return {
      [CollectionTargetLocation.Image]: field,
    };
  }
  if (field.type === CollectionFieldType.URL) {
    const collectionForUrl = getCollectionEmbedLocationForURL(field, schema);
    if (!collectionForUrl) {
      return {};
    }
    return { [CollectionTargetLocation.ActionURL]: collectionForUrl };
  }
  if (field.type === CollectionFieldType.String) {
    const embedLocationForString = getCollectionEmbedLocationForString(field, schema);
    if (!embedLocationForString) {
      return {};
    }
    return {
      [CollectionTargetLocation.Text]: getCollectionEmbedLocationForString(field, schema),
    };
  }
  return {};
};
